import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import * as ProductActions from '@core/actions/product.actions';
import * as fromRoot from '@core/reducers/root.reducer';
import * as ProformaActionTypes from '@app/modules/core/actions/proforma.actions';

@Component({
  selector: 'app-product-disabled-fob',
  templateUrl: './product-disabled-fob.component.html',
  styleUrls: ['./product-disabled-fob.component.css']
})
export class ProductDisabledFobComponent implements OnInit, OnDestroy {
  constructor(public activeModal: NgbActiveModal, private store: Store<any>) {}

  _alive = true;
  ProductIdsDisabledByFob: any = [];
  FollowId;
  ParentId;
  products$ = this.store.pipe(select(fromRoot.getProducts));
  products;
  chosenFob;
  previousFob;
  CountryId;
  ProformaId;

  ngOnInit() {
    this.store.dispatch(
      new ProductActions.LoadByFollow(this.FollowId, { type: 'minimal' })
    );

    this.products$.subscribe(x => {
      this.products = x.filter(product =>
        this.ProductIdsDisabledByFob.includes(product.id)
      );
    });
  }

  ngOnDestroy() {
    this._alive = false;
  }

  confirmed() {
    this.store.dispatch(
      new ProformaActionTypes.Update(this.ProformaId, {
        fobType: this.chosenFob,
        previousFob: this.previousFob,
        FollowId: this.FollowId,
        ParentId: this.ParentId,
        CountryId: this.CountryId,
        includeProvider: true,
        discrepanciesView: true
      })
    );
    this.activeModal.dismiss(true);
  }
}
